import { CAR } from './car.config';
import { HOUSE } from './house.config';
import { CONTENTS } from './contents.config';
import { TRAVEL } from './travel.config';
import { VACATION_HOME } from './vacation-home.config';
import { ANIMAL } from './animal.config';
import { BOAT } from './boat.config';
import { MOTORCYCLE } from './motorcycle.config';
import { VETERAN_CAR } from './veteran-car.config';
import { ACCIDENT } from './accident.config';
import { MOPED } from './moped.config';
import { VALUABLES } from './valuables.config';
import { TRAILER } from './trailer.config';
import { MOBILE_HOME } from './mobile-home.config';
import { TRAILER_HOME } from './trailer-home.config';
import { TRACTOR } from './tractor.config';
import { SNOWMOBILE } from './snowmobile.config';
import { VACATION_HOME_ABROAD } from './vacation-home-abroad.config';
import { ANSVARFORSIKRING } from './ansvarsforsikring.config';
import { DENTAL } from './dental.config';
import { RENT_HOUSE } from './rent-house.config';
import { HOUSE_ROT } from './house-rot.config';
import { ILLNESS } from './illness.config';
import { CRITICAL_ILLNESS } from './critical-illness.config';
import { INCOME_ACCIDENT } from './income-accident.config';
import { INCOME } from './income.config';
import { POLICY } from './policy.config';
import { PENSION } from './pension.config';
import { RENTAL } from './rental.config';
import { CHILD } from './child.config';
import { CHILDREN } from './children.config';
import { LIFE } from './life.config';
import { HEALTH } from './health.config';
import { NATURSKADE } from './naturskade.config';
import { GREEDY_FEE } from './greedy-fee.config';
import { DEBT } from './debt.config';
import { UNREGISTERED_MOTO } from './unregistered-moto.config';
import { FEE } from './fee.config';
import { OFFER } from './offer.config';

export const PRODUCTS_MAP_WATERCIRCLES = {
  CAR,
  HOUSE,
  CONTENTS,
  TRAVEL,
  VACATION_HOME,
  ANIMAL,
  BOAT,
  MOTORCYCLE,
  VETERAN_CAR,
  ACCIDENT,
  MOPED,
  VALUABLES,
  TRAILER,
  MOBILE_HOME,
  TRAILER_HOME,
  TRACTOR,
  SNOWMOBILE,
  VACATION_HOME_ABROAD,
  ANSVARFORSIKRING,
  DENTAL,
  RENT_HOUSE,
  HOUSE_ROT,
  ILLNESS,
  CRITICAL_ILLNESS,
  INCOME_ACCIDENT,
  INCOME,
  POLICY,
  PENSION,
  RENTAL,
  CHILD,
  CHILDREN,
  LIFE,
  HEALTH,
  NATURSKADE,
  GREEDY_FEE,
  DEBT,
  UNREGISTERED_MOTO,
  FEE,
  OFFER
};
